import { FC } from 'react';
import { MetaTags } from './MetaTags';
import { StructuredData } from './StructuredData';
import { MetaData, StructuredData as StructuredDataType } from './types';
import { seoConfig } from './config';

interface DynamicSEOProps {
  meta?: Partial<MetaData>;
  structuredData?: StructuredDataType;
}

export const DynamicSEO: FC<DynamicSEOProps> = ({ meta = {}, structuredData }) => {
  const defaultStructuredData: StructuredDataType = {
    type: 'WebSite',
    name: meta.title || seoConfig.defaultTitle,
    description: meta.description || seoConfig.defaultDescription,
    url: meta.url || seoConfig.baseUrl,
    image: meta.image || seoConfig.defaultImage
  };

  return (
    <>
      <MetaTags meta={meta} />
      <StructuredData data={structuredData || defaultStructuredData} />
    </>
  );
};